import * as tslib_1 from "tslib";
import { RequestHeaders } from './utilities';
import { GetTwoFactorAuthenticationDetailsUrl, VerifyTwoFactorAuthenticationMethodUrl } from '../constants';
export const twoFactorAuthentication = (api) => ({
    initiateSmsMethodVerification: (requestQueryParams) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api
            .authenticated()
            .post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({ queryParams: requestQueryParams }, RequestHeaders));
    }),
    initiateEmailMethodVerification: (requestQueryParams) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api
            .authenticated()
            .post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({ queryParams: requestQueryParams }, RequestHeaders));
    }),
    finalizeSmsMethodVerification: (requestQueryParams) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api
            .authenticated()
            .post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({ queryParams: requestQueryParams }, RequestHeaders));
    }),
    finalizeEmailMethodVerification: (requestQueryParams) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api
            .authenticated()
            .post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({ queryParams: requestQueryParams }, RequestHeaders));
    }),
    getDetails: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api
            .authenticated()
            .get(GetTwoFactorAuthenticationDetailsUrl, {}, RequestHeaders);
    }),
});
//# sourceMappingURL=twoFactorAuthentication.js.map